var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoyalty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6F5CFF",
  fillRule: "evenodd",
  d: "M34 14H10v16h24zM13.597 25.864a.98.98 0 0 1 .986-.98c.548 0 1.012.435 1.012.98 0 .546-.464 1.008-1.012 1.008s-.986-.462-.986-1.008M16.63 17.2l3.78 9.54h1.328l1.356-3.666 1.355 3.665h1.329l3.78-9.539h-1.782l-2.684 6.95-1.137-3.068 1.602-3.885h-1.724l-.74 1.935-.738-1.935H20.63l1.603 3.885-1.138 3.067-2.684-6.949z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.597 25.865c0-.546.438-.981.986-.981s1.012.435 1.012.98c0 .546-.464 1.008-1.012 1.008s-.986-.462-.986-1.007M20.41 26.739l-3.78-9.54h1.783l2.683 6.95 1.138-3.068-1.602-3.885h1.724l.739 1.935.739-1.935h1.724l-1.602 3.885 1.138 3.068 2.684-6.95h1.78l-3.78 9.54h-1.327l-1.356-3.666-1.355 3.666z"
})));
export default SvgLoyalty;